import { Injectable } from '@angular/core';
import { ToastService } from '../toast/toast.service';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { LanguageService } from '../language/language.service';
import { SpinnerService } from '../spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

    constructor(private _toastService: ToastService,
        private _spinnerService: SpinnerService,
        private _router: Router,
        private _languageService: LanguageService) { }

    catchBadResponse: (errorResponse: any) => Observable<any> = (errorResponse: any) => {
        let msg = "";

        console.log('error code: ' + errorResponse.status);
        
        if (errorResponse.status == 400) {
            //msg = "dogodila_se_greska";
            //msg = this._languageService.translate(msg);

            let msgInfo = "";
            if (errorResponse.error != null && errorResponse.error != undefined) {
                // handle validation error
                console.log(errorResponse.error);
                let validationErrorDictionary = errorResponse.error;
                for (var fieldName in validationErrorDictionary) {
                    if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                        msgInfo = errorResponse.error[fieldName];
                        //msgInfo = msgInfo.replace(/["']/g, "");
                        break;
                    }
                }
                //msgInfo = errorResponse.error.errors[0];
                //msgInfo = msgInfo.replace(/["']/g, "");
                msgInfo = this._languageService.translate(msgInfo);
            }

            if (msgInfo.length) {
                msg = this._languageService.translate("poruka_sistema") + msgInfo;
            }
        }
        else if (errorResponse.status == 401) {
            this._router.navigate(['/login']);
            msg = "sesija_istekla";
            msg = this._languageService.translate(msg);
        }
        else if (errorResponse.status == 403) {
            this._router.navigate(['/login']);
            msg = "sesija_istekla";
            msg = this._languageService.translate(msg);
        }
        else if (errorResponse.status == 405) {
            this._router.navigate(['/login']);
            msg = "metoda_nije_dozvoljena";
            msg = this._languageService.translate(msg);
        }
        else if (errorResponse.status == 500) {
            console.log(errorResponse);
            msg = "zahtjev_za_web_servis_pogresan";
            msg = this._languageService.translate(msg);
        }
        else if (errorResponse.status == 0) {
            msg = "servis_nedostupan";
            msg = this._languageService.translate(msg);
        }
        else {
            console.log(errorResponse.status);
            msg = "dogodila_se_greska";
            msg = this._languageService.translate(msg);
        }

        this._toastService.activate(msg, "alert-dangerToast");
        this._spinnerService.hide();
        return of(false);
    }
}
